import { render, staticRenderFns } from "./SelectList.vue?vue&type=template&id=2f3f529e&scoped=true&"
import script from "./SelectList.vue?vue&type=script&lang=ts&"
export * from "./SelectList.vue?vue&type=script&lang=ts&"
import style0 from "./SelectList.vue?vue&type=style&index=0&id=2f3f529e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f3f529e",
  null
  
)

export default component.exports